import decodeJwt from "./decodeJwt";

export default function isValidJwt(token: string | null) {
  if (!token) return false;
  const decoded = decodeJwt(token);

  // if (!isValid && removeToken) {
  //   localStorage.removeItem("accessToken");
  //   localStorage.removeItem("refreshToken");
  // }

  return decoded.exp * 1000 > Date.now();
}
